(function ($, w, d, undefined) {
    'use strict';

    function ExtrasProductTable() {
        this.selectorContainer = '.module-extras-product-table';
        this.selectorToggle = '.extras-table-column.yearly-limits';
        this.selectorWrapper = '.extras-table-row';
        this.activeClass = 'active';

        this.$containers = $(this.selectorContainer);

        var self = this;
        this.$containers.each(function() {
            self.setEvents(this);
        });
    }

    ExtrasProductTable.prototype.setEvents = function (elem) {
        var self = this;
        $(this.selectorToggle, elem).bind('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            self.toggle(this);
        });
    };

    ExtrasProductTable.prototype.toggle = function(elem) {
        var $parent = $(elem).parents(this.selectorWrapper);
        if($parent.hasClass(this.activeClass)) {
            this.close($parent);
        }
        else {
            this.open($parent);
        }
    };

    ExtrasProductTable.prototype.close = function(elem) {
        elem.removeClass(this.activeClass);
    };

    ExtrasProductTable.prototype.open = function(elem) {
        elem.addClass(this.activeClass);
    };


    w.THF = w.THF || {};
    w.THF.Interface = w.THF.Interface || {};
    w.THF.Interface.ExtrasProductTable = ExtrasProductTable;
})(jQuery, window, document);